import { render, staticRenderFns } from "./SavingInfoBar.vue?vue&type=template&id=f6b679e6&scoped=true"
import script from "./SavingInfoBar.vue?vue&type=script&lang=ts"
export * from "./SavingInfoBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b679e6",
  null
  
)

export default component.exports